export default {
  footNoteApproximation: 'These values are estimated for the ranges you\'re targeting.',
  footNoteEstimate: ' Keep them in mind for experiment planning, but remember they\'re approximations!',
  durationDayLabel: 'duration of experiment (days)',
  trafficLabel: 'traffic per variant',
  mdeTooltip: 'A minimum detectable effect (MDE) refers to the minimum effect size that the experiment will likely be able to detect to a certain degree of statistical significance.',
};
